import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { LanguageKeys } from '../CommonTypes';
import { localization } from '../localization';

import LicenseItemWrapper from './LicenseListItem.styles';

import { LicenseListItem } from './Licenses';

export interface LicenseProps {
  item: LicenseListItem;
  lang: LanguageKeys;
  
  openLink: (link: string, newTab: boolean) => void;
}

export const LicensesListItem: React.FC<LicenseProps> = ({
  item: { username, name, version, licenses, repository, licenseUrl },
  lang,
  openLink
}) => {
  let title = name;
  if (username) {
    if (title.toLowerCase() !== username.toLowerCase()) {
      title = localization[lang].by(title, username);
    }
  }

  return (
    <LicenseItemWrapper>
      <div onClick={() => openLink(repository, true)} >
        <span>{title}</span>
        <div>
          <span className='Linked' onClick={e => { e.stopPropagation(); openLink(licenseUrl, true); }}><u>{licenses}</u></span>
        </div>
        <span>{version}</span>
        <FontAwesomeIcon className='IconRight' icon={ 'chevron-right' } />
      </div>
    </LicenseItemWrapper>
  );
};

export default LicensesListItem;